import {useEffect, useState, useMemo} from 'react'

const formatRegex = /\$\{\[([^\]]+)\]\}/;

function getText(match, value, formatter){
  const toReplace = match[0];
  return match.input.replace(toReplace, formatter.format(value));
}

const defaultFormat = `\${["en-En",{"style":"decimal"}]}`;

const defaultEase = t=>t;

export default function useCountdown({
  duration=10,
  ease=defaultEase,
  started=false,
  fromValue,
  toValue,
  format
}){
  duration *= 1000;
  const [value,setValue] = useState();
  const [startTime,setStartTime] = useState();
  const [running,setRunning] = useState(false);
  const [match,formatter] = useMemo(()=>{
    if(!format) return [null,null];
    const match = format.match(formatRegex);
    const formatArguments = JSON.parse(`[${match[1]}]`);
    const formatter = new Intl.NumberFormat(...formatArguments);
    return [match,formatter];
  },[format]);

  useEffect(()=>{
    setValue(fromValue);
    setRunning(started);
    if(started) setStartTime(performance.now());
  },[started,fromValue])

  useEffect(()=>{
    if(!running) return;

    let ticking = true;

    function tick(time){
      if(!ticking) return;
      const t = Math.min(1,Math.max(0,time / (startTime + duration)));
      setValue(fromValue + (toValue - fromValue) * ease(t));
      if(t>=1){
        setRunning(false);
      }else{
        frame = requestAnimationFrame(tick);
      }
    }

    let frame = requestAnimationFrame(tick);

    return ()=>{
      ticking = false;
      cancelAnimationFrame(frame);
    }
  },[running,fromValue,toValue,duration,startTime,setRunning,ease]);

  return match&&formatter?getText(match,value,formatter):Math.round(value);
}